import { render, staticRenderFns } from "./PermissionModal.vue?vue&type=template&id=cc763620&scoped=true"
import script from "./PermissionModal.vue?vue&type=script&lang=js"
export * from "./PermissionModal.vue?vue&type=script&lang=js"
import style0 from "./PermissionModal.vue?vue&type=style&index=0&id=cc763620&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc763620",
  null
  
)

export default component.exports